import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import Error from './form-input-error';
import { injectIntl } from 'react-intl';

import Label from '../label';
import Text from './form-text'

//https://github.com/zippytech/react-date-picker
//https://hacker0x01.github.io/react-datepicker/
//=> https://wangzuo.github.io/input-moment


// import DatePicker, {DateField} from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';

import DatePicker from 'react-date-picker'

import './form-date-time-picker.styl'
class DateTimePicker extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        date: PropTypes.instanceOf(moment),
        minDate: PropTypes.object,
        maxDate: PropTypes.object,
        dateFormat: PropTypes.string,
        errorStr: PropTypes.string,
        disabled: PropTypes.bool,
        onChange: PropTypes.func
    }
    static defaultProps = {
        errorStr: 'app.error',
        disabled: false
    }

    state = {
        date: this.props.date,
        disabled: this.props.disabled,
        error: false
    }

    handleChange(newDdate) {
        let { onChange = false } = this.props
        if(!onChange) {
            return
        }
        let {date} = this.state
        let promise = onChange(date)
        !promise._state && this.setState({loading: true})
        promise.then(value => setTimeout(()=>{
            this.setState({loading: false, error: false, date: newDdate})
        }, 10))
        .catch( e => this.setState({loading: false, error: true, date}));
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { label, minDate, maxDate, dateFormat='DD/MM/YYYY', className=false, errorStr, intl } = this.props
        let { error=false, loading=false, disabled, date=new Date() } = this.state

        return <div className={"form form-date-time-picker" + (className ? ' ' + className : '')}>
            <Label>{label}</Label>
            { disabled ? <Text disabled={true} value={moment(date).format(dateFormat)} /> :
                <div className={'form-value' + (error?' error':'')}>
                    <DatePicker
                        {...{minDate}}
                        {...{maxDate}}

                        value={date}
                        onChange={this.handleChange.bind(this)}

                        locale={intl.locale} />
                    <Error visible={error} message={errorStr} />
                </div>}
        </div>
    }
}

export default injectIntl(DateTimePicker)

